import React, { Component, Fragment } from 'react'
import { Helmet } from 'react-helmet'
import c from 'classnames'
import PropTypes from 'prop-types'

export class Page extends Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    pageClassName: PropTypes.string,
    pageContentClassName: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    header: null,
    children: null,
    pageClassName: '',
    title: '',
  }

  render() {
    const { children, title, pageContentClassName, pageClassName } = this.props
    return (
      <Fragment>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className={c('im-page', pageClassName)}>
          <section className={c('page-content', pageContentClassName)}>{children}</section>
        </div>
      </Fragment>
    )
  }
}

export default Page
